import React from "react";
import { NavLink } from "react-router-dom";

const navItems = [
  { to: "/ekyc", label: "eKYC", icon: "🪪" },
  { to: "/reports", label: "I-OnAsia Reports", icon: "📊" },
];

export default function Sidebar() {
  return (
    <nav
      style={{
        width: 220,
        background: "#0b2545",
        color: "#fff",
        minHeight: "100vh",
        paddingTop: 24,
      }}
    >
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          style={({ isActive }) => ({
            display: "flex",
            alignItems: "center",
            gap: 10,
            padding: "12px 24px",
            color: "#fff",
            background: isActive ? "#13315c" : "transparent",
            borderLeft: isActive ? "3px solid #c9a24b" : "3px solid transparent",
            fontSize: 14,
            fontWeight: 500,
          })}
        >
          <span>{item.icon}</span>
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
